import React from 'react';

const PlayerCardLegacy = () => {
  return (
    <div
      className="ftbl__players-card ftbl__players-card--has-head-shot"
      data-id="171366"
      style={{ backgroundColor: '#4693C8' }}
    >
      <div className="ftbl__player-card__header">
        <div>
          <div className="ftbl__player-report-card__badge">mvp</div>
        </div>
        <div>
          <div className="ftbl__player-card__team">
            <img src="https://test.static.sky.it/images/skysport/it/calcio/squadre/team_logo_459.png" alt="Napoli" />
          </div>
        </div>
      </div>
      <div className="ftbl__player-card__player">
        <div className="ftbl__player-card__image">
          <img
            data-livedata-placeholder-action="playerPagesHeroPlaceholder"
            data-livedata-placeholder="https://static.sky.it/images/skysport/configurations/placeholders/football/SkySpport-player_placeholder.png"
            src="https://test.static.sky.it/images/skysport/it/calcio/serie-a/probabili-formazioni/superscudetto/512/171366.png"
            alt="Alex Meret"
          />
        </div>
        <div className="ftbl__player-card-footer__info-wrapper">
          <div className="ftbl__player-card-footer__info">
            <div className="ftbl__player-card-footer__name">
              <span className="ftbl__text ftbl__text--span ftbl__text--color-blue ftbl__text--font-size-16">Alex</span>
              <span className="ftbl__text ftbl__text--a ftbl__text--color-blue ftbl__text--font-size-20 ftbl__text--weight-500">
                Meret
              </span>
            </div>

            <div className="ftbl__player-card-footer__score">
              <span className="ftbl__text ftbl__text--span ftbl__text--color-blue ftbl__text--font-size-14 ftbl__player-card-footer__text--uppercase ftbl__text--weight-500">
                voto
              </span>
              <span className="ftbl__text ftbl__text--span ftbl__text--color-blue ftbl__text--font-size-32--34 ftbl__text--weight-500 ftbl__player-card-footer__points">
                2.5
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayerCardLegacy;
